/*eslint-disable*/
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";

import APIClient from "../client";
import config from "../config.js";
import {useAuth} from "../components/Authentication/AuthProvider";

import CountUp from "react-countup";
import VisibilitySensor from 'react-visibility-sensor';
import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import HorizontalLogoBlue from '../assets/img/JUMO_Logo_dark.svg';

import "@fontsource/montserrat";



const client = new APIClient(config);


export default function Index() {
    const [summaryData, setSummaryData] = useState();
    const [second, setSecond] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        try {
            fetchSummaryData();
        } catch (err) {
            setSecond(false);
        } finally {

        }
    }, []);

    const fetchSummaryData = () => {
        client.getSummary().then((data) => {
            if (data['data']['data']['status'] === 200) {
                setSummaryData(data['data']['data']);
                setSecond(true);
            } else {
                setSecond(false);
            }
        });
    };

    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "Home";

    return (
        <>

            <section className="relative bg-center bg-repeat-y bg-cover h-screen grad-image w-full">
                <div className="mx-auto w-full ">
                    <div className="flex flex-wrap items-center">
                        <div className="w-full lg:w-6/12 h-screen text-white">
                            <div className="flex items-center justify-center h-full">
                                <div className="flex items-center align-middle">
                                    <div className="items-center mx-auto">
                                        <Link
                                            className="get-started text-blue text-16-19-bold px-8 py-3 rounded mb-1 bg-yellow "
                                            to="/login">Sign In</Link>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="w-full lg:w-6/12 h-screen tems-center bg-white border-0">
                            <div className="w-full flex flex-wrap items-center">
                                <div className="w-full md:w-10/12 lg:px-12 md:px-12 sm:px-8">

                                    <div className="container relative z-40 mx-auto flex">
                                        <div className="w-full">
                                            <div
                                                className="relative flex flex-col min-w-0 break-words text-blue text-center w-full mb-6 lg:mb-1 md:mb-1 sm:mb-1">
                                                <img src={HorizontalLogoBlue} className="w-6/12 mx-auto"/>
                                                <h1 className="px-2 lg:py-6 md:py-4 sm:py-2 hl-48">
                                                    Intelligent banking technology

                                                </h1>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full">
                                        <div
                                            className="relative flex flex-col min-w-0 break-words text-blue text-center w-full mb-6 md:mb-2 lg:mb-2">
                                            <h1 className="px-2 py-6 md:py-2 lg:py-2 text-42">
                                                <span className="percentage-span">$</span>
                                                <CountUp
                                                    start={1}
                                                    end={second ? (Math.round(summaryData['total_disbursed']/ 1_000_000)): (8402)}
                                                    duration={1.5}
                                                    useEasing={true}
                                                >
                                                    {({countUpRef, start}) => (
                                                        <VisibilitySensor onChange={start} delayedCall>
                                                            <span ref={countUpRef}/>
                                                        </VisibilitySensor>
                                                    )}
                                                </CountUp>
                                                <span className="percentage-span">m</span>
                                            </h1>
                                            <p className="px-12 text-20-29">Disbursements</p>
                                        </div>
                                    </div>

                                        <div className="w-full">
                                            <div
                                                className="relative flex flex-col min-w-0 break-words text-blue text-center w-full mb-6 md:mb-2 lg:mb-2">
                                                <h1 className="px-2 py-6 md:py-2 lg:py-2 text-42">
                                                    <CountUp
                                                        start={1}
                                                        end={second ? (Math.round(summaryData['total_loans']/ 1_000_000)): (257)}
                                                        duration={1.5}
                                                        decimals={0}
                                                        decimal="."
                                                        useEasing={true}
                                                    >
                                                        {({countUpRef, start}) => (
                                                            <VisibilitySensor onChange={start} delayedCall>
                                                                <span ref={countUpRef}/>
                                                            </VisibilitySensor>
                                                        )}
                                                    </CountUp>
                                                    <span className="percentage-span">m</span>
                                                </h1>
                                                <p className="px-12 text-20-29">Loans</p>
                                            </div>
                                        </div>

                                        <div className="w-full">
                                            <div
                                                className="relative flex flex-col min-w-0 break-words text-blue text-center w-full mb-6 md:mb-2 lg:mb-2">
                                                <h1 className="px-6 py-6 md:py-2 lg:py-2 text-42">
                                                    <CountUp
                                                        start={1}
                                                        end={second ? (Math.round((summaryData['total_customers'])/ 1_000_000)): (34)}
                                                        duration={1.5}
                                                        decimals={0}
                                                        decimal="."
                                                        useEasing={true}
                                                    >
                                                        {({countUpRef, start}) => (
                                                            <VisibilitySensor onChange={start} delayedCall>
                                                                <span ref={countUpRef}/>
                                                            </VisibilitySensor>
                                                        )}
                                                    </CountUp>
                                                    <span className="percentage-span">m</span>
                                                </h1>
                                                <p className="px-8 text-20-29">Customers</p>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
            </section>


        </>
);
}
